export default {
    getSelectedTreeComponent(state) {
        return state.treeSelectedItem
    },
    getAssetDetailsPlayer(state){
        return state.activeAssetDetailsPlyr;
    }
};
